import { render } from "./BellSiimpleIcon.vue?vue&type=template&id=5a66359a"
const script = {}

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__